import React, { useEffect } from 'react'
import './App.css'
import { BrowserRouter } from 'react-router-dom'
import { QueryClientProvider, QueryClient } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import { ThemeProvider } from '@mui/material/styles'
import { lightTheme, darkTheme } from './theme'
import { CssBaseline } from '@mui/material'
import BackOfficeRouter from './router'
import { useGlobalStore } from './store'
import { CONST_APP_VERSION_PATH, isProd, isReportsPage } from './constants';
import PerformanceMonitor from './util/performance/performanceMonitor';
import { showCustomDevTool } from './util'

const queryClient = new QueryClient({
  defaultOption: { queries: { retry: 3, retryDelay: 1500 } },
})

const APP_VERSION = process.env.REACT_APP_VERSION;  // or set this yourself in build

const applicationVersionCheck = () => {
  fetch(CONST_APP_VERSION_PATH)
    .then((res) => res.json())
    .then((obj) => {
      if(obj.version !== APP_VERSION) {
        // console.warn(`App version mismatch: env version ${APP_VERSION} does not match version.json version ${obj.version}`);
        console.warn(`App version mismatch: client Version ${APP_VERSION} and server version ${obj.version}`);
        
        const url = new URL(window.location.href);
        url.searchParams.set('_mm', Date.now());
        window.location.replace(url.toString());
      } else {
        console.log(`App version: ${APP_VERSION}`);
      }
    })
    .catch((err) => {
      console.error('Error fetching app version:', err);
    });
}

const useSyncSession = () => {
  useEffect(() => {
  // IMPORTANT CODE, THIS WILL SYNC LOGOUT/LOGIN ACROSS TABS
    const handleStorageChange = (event) => {
      // 1. Check if the changed item is specifically your 'user' key
      if (event.key === 'user') {
        if (window.location.pathname === '/') {
          return; 
        }
        // 2. Logic for Logout: If 'user' was removed in Tab 2, 
        // newValue will be null.
        if (!event.newValue) {
          // console.log("User logged out in another tab. Redirecting...");
          window.location.href = '/';
          return;
        }
        
        // 3. Logic for Switch User: If Tab 2 logged in as someone else,
        // we reload Tab 1 to fetch the correct data for the new UserId.
        // console.log("User changed in another tab. Syncing...");
        window.location.href = '/projects';
      }
    };

    // This listener only triggers for changes made in OTHER tabs
    window.addEventListener('storage', handleStorageChange);

    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);
}

const App = () => {
  const { theme } = useGlobalStore()
  /*
  useEffect(() => {
    if(isProd){
      // do the initial check immediately
      setTimeout(() => {
        applicationVersionCheck();
      }, 1000);

      // optionally: repeat checks every X seconds (e.g. every 30 seconds)
      const interval = setInterval(() => {
        applicationVersionCheck();
      }, 4 * 60 * 1000);

      return () => {
        clearInterval(interval);
      };
    }
  }, []);
  */
  useSyncSession()

  return (
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme === 'dark' ? darkTheme : lightTheme}>
          <CssBaseline />
          <BackOfficeRouter />
        </ThemeProvider>
        <ReactQueryDevtools initialIsOpen={false} position='bottom-right' />
      </QueryClientProvider>
      {!isProd && showCustomDevTool('dev') && <PerformanceMonitor />}
    </BrowserRouter>
  )
}

export default App
